import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { api } from '@/lib/api';

export default function AdminAnalytics() {
    const [malls, setMalls] = useState([]);
    const [analytics, setAnalytics] = useState({});

    useEffect(() => {
        api.get('/admin/malls').then(async ({ data }) => {
            setMalls(data);
            const results = await Promise.all(data.map((m) => api.get(`/admin/analytics/mall/${m.id}`).then(({ data }) => [m.id, data])));
            setAnalytics(Object.fromEntries(results));
        });
    }, []);

    return (
        <AdminLayout>
            <div className="p-10" data-testid="admin-analytics-page">
                <div className="overline">Analytics</div>
                <h1 className="font-serif text-4xl text-navy mt-2 mb-8">Mall Performance</h1>
                <div className="space-y-6">
                    {malls.map((m) => {
                        const a = analytics[m.id];
                        if (!a) return null;
                        return (
                            <div key={m.id} className="bg-white border border-border-subtle p-6 grid md:grid-cols-6 gap-4 items-center">
                                <div className="md:col-span-2 flex items-center gap-4">
                                    <img src={m.hero_image} alt="" className="w-20 h-20 object-cover" />
                                    <div>
                                        <div className="font-serif text-lg text-navy">{m.short_name}</div>
                                        <div className="text-xs text-text-tertiary">{m.city}</div>
                                    </div>
                                </div>
                                <Metric label="Brands" value={a.brands} />
                                <Metric label="Offers" value={a.offers} />
                                <Metric label="Approved Bills" value={a.approved_bills} />
                                <Metric label="Captured Sales" value={`₹${(a.captured_sales || 0).toLocaleString('en-IN')}`} small />
                            </div>
                        );
                    })}
                </div>
            </div>
        </AdminLayout>
    );
}

function Metric({ label, value, small }) {
    return (
        <div>
            <div className="overline">{label}</div>
            <div className={`font-serif ${small ? 'text-xl' : 'text-3xl'} text-navy mt-1`}>{value}</div>
        </div>
    );
}
